import { combineEpics } from "redux-observable";
import { checkExpGroupClaimEpicReducer, checkWorkspaceClaimEpicReducer } from "./UserAccess.ducks.js";
const UserAccessEpics = combineEpics(checkExpGroupClaimEpicReducer.epic, checkWorkspaceClaimEpicReducer.epic);
export {
  UserAccessEpics as default
};
//# sourceMappingURL=UserAccess.epics.js.map
